(function () {
    try {
      /* main variables */
      var debug = 0;
      var variation_name = "";
      var $;
      /* all Pure helper functions */
  
      function waitForElement(selector, trigger, delayInterval, delayTimeout) {
        var interval = setInterval(function () {
          if (
            document &&
            document.querySelector(selector) &&
            document.querySelectorAll(selector).length > 0
          ) {
            clearInterval(interval);
            trigger();
          }
        }, delayInterval);
        setTimeout(function () {
          clearInterval(interval);
        }, delayTimeout);
      }
  
      function live(selector, event, callback, context) {
        function addEvent(el, type, handler) {
          if (el.attachEvent) el.attachEvent('on' + type, handler);
          else el.addEventListener(type, handler);
        }
        this.Element &&
          (function (ElementPrototype) {
            ElementPrototype.matches =
              ElementPrototype.matches ||
              ElementPrototype.matchesSelector ||
              ElementPrototype.webkitMatchesSelector ||
              ElementPrototype.msMatchesSelector ||
              function (selector) {
                var node = this,
                  nodes = (node.parentNode || node.document).querySelectorAll(selector),
                  i = -1;
                while (nodes[++i] && nodes[i] != node);
                return !!nodes[i];
              };
          })(Element.prototype);
        function live(selector, event, callback, context) {
          addEvent(context || document, event, function (e) {
            var found,
              el = e.target || e.srcElement;
            while (el && el.matches && el !== context && !(found = el.matches(selector))) el = el.parentElement;
            if (found) callback.call(el, e);
          });
        }
        live(selector, event, callback, context);
      };
  
      live('.product-block .add-to-cart', 'mousedown', function () {
        waitForElement('#CartPopup .upcart-footer', init, 50, 15000);  
      });
  
      var cartTrustSection = `
        <div class="eg-cart-trustSec">
          <div class="eg-cart-trustpilot">
            <div class="eg-cart-trust-image"><img src="https://cdn.shopify.com/s/files/1/0683/5935/6720/files/Frame_13682.png?v=1734346707"></div>
            <div class="eg-cart-trust-image"><img src="https://cdn.shopify.com/s/files/1/0683/5935/6720/files/star_1.png?v=1730965936"></div>
            <span>TrustScore 4.8 | 1,437 reviews</span>
          </div>
          <div class="eg-review-content">
            <div class="eg-custom__img">
              <img src="https://cdn.shopify.com/s/files/1/0683/5935/6720/files/Customer_Glenn_picture.png?v=1734692799">
            </div>
            <div class="eg-custom__content">
              <p>For DIYs & hardworking folk, this is the watch for you, I do work on my property everyday and the last thing I need to worry about aswell is my tools breaking on me...</p>
              <h2>- Glenn Jeffrey</h2>
            </div>
          </div>
        </div>`;

      /* Variation Init */
      function init() {
        document.body.classList.add('AB0042');
        const destEl = document.querySelector('#CartPopup .upcart-footer');
        if(destEl && !document.querySelector('.eg-cart-trustSec')) {
          destEl.insertAdjacentHTML('afterend', cartTrustSection);
        }
      }
  
      /* Initialize variation */
      waitForElement('#CartPopup .upcart-footer', init, 50, 15000);  
    } catch (e) {
      if (debug) console.log(e, "error in Test" + variation_name);
    }
  })();